// src/routes/domains/core/index.ts
import type { AppRoute } from '../../core/types';
import { coreRoutes } from './core.routes.tsx';



/**
 * Lazy export wrapper for Core routes.
 * Enables code splitting: the Core routes chunk will only load when needed.
 */
export const loadCoreRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(coreRoutes);
};